export const RUC_EMPRESA = '1891744672001'